<template>
  <div id="app">
    <header v-show="!isPc" class="phone_header">苏州 市机动车排放阶段审核认定</header>
    <header v-show="isPc" class="pc_header"></header>
    <router-view/>
  </div>
</template>
<script>
import { Dialog, Toast ,Lazyload } from 'vant'
export default {
  name:'app',
  data(){
    return{
      isPc:false
    }
  },   
  methods:{
    showLoading(){//加载中
			this.toast = this.$toast.loading({message:'正在加载，请稍后...',duration:0,mask:true});
		},
    // 时间格式化函数
    timeFomat(fmt,date){
      var o = {   
        "M+" : date.getMonth()+1,                 //月份   
        "d+" : date.getDate(),                    //日   
        "h+" : date.getHours(),                   //小时   
        "m+" : date.getMinutes(),                 //分   
        "s+" : date.getSeconds(),                 //秒   
        "q+" : Math.floor((date.getMonth()+3)/3), //季度   
        "S"  : date.getMilliseconds()             //毫秒   
      };   
      if(/(y+)/.test(fmt))   
        fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));   
      for(var k in o)   
        if(new RegExp("("+ k +")").test(fmt))   
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));   
      return fmt; 
    },
    login(){
      let that = this;
      this.showLoading();
      this.$get("hello", {}).then(response => {
        that.$toast.clear();
      })
    },
    // 定义alert
    vueAlert(text,activity){
      Dialog.alert({
        title: '提示',
        message: text
      }).then(() => {
        activity && activity();
      });
    },
    // 定义大分辨率alert
    vueAlert1(text,activity){
      this.$alert(text, '提示', {
        showClose:false,
        callback: action => {
          activity && activity();
        }
      });
    },
    // 定义comfirm
    vueComfirm(text,activity,cancel){
      Dialog.confirm({
        title: '提示',
        message: text
      }).then(() => {
        activity && activity();
      }).catch(() => {
        cancel && cancel();
      });
    },
    // 定义comfirm
    vueComfirm1(text,activity,cancel){
      this.$confirm(text, '提示', {
          showClose:false
        }).then(() => {
          activity && activity();
        }).catch(() => {
          cancel && cancel();
        });
    },
  },
  mounted(){
    this.isPc = window.innerWidth>640?true:false;
    // this.login()
  }
}
</script>

<style>
*{
  margin:0;
  padding: 0;
}
html,body{
  width: 100vw;
  height: 100vh;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: rgb(248,248,248);
  min-height: 100vh;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
header{
  height: 6vh;
  line-height: 6vh;
  color: #fff;
  background: linear-gradient(left,#3C80F7, #1058D1); /* 标准的语法 */
  background: -webkit-linear-gradient(left,#3C80F7, #1058D1); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(left,#3C80F7, #1058D1); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(left,#3C80F7, #1058D1); /* Firefox 3.6 - 15 */
}
.phone_header{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 100;
}
.pc_header{
  height: 10vh;
  background:url('assets/header.png') no-repeat;
  background-size: 100% 100%;
}
.btn{
  margin-top: 2vh;
  width: 100%;
  line-height: 7vh;
  color: #fff;
  border-radius: 6px;
  outline: none;
  border: none;
  background: linear-gradient(left,#3C80F7, #1058D1); /* 标准的语法 */
  background: -webkit-linear-gradient(left,#3C80F7, #1058D1); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(left,#3C80F7, #1058D1); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(left,#3C80F7, #1058D1); /* Firefox 3.6 - 15 */
}
.new_input .el-input__inner{
  width: 100%;
  line-height: 6vh;
  height: 6vh;
  background: none;
  border: none;
  outline: none;
  color:rgb(198, 203, 212);
  border-bottom: 1px solid rgb(198, 203, 212);
  font-size: 16px;
  text-indent: 5px;
  border-radius: 0;
}
/* 提示的css */
body .el-notification__content{
  text-align:left;
}
</style>
